<div class="content-label-container">
    <h1 [style.color]="titleColor" translate>navigation.voice</h1>
    <p translate>voice.subtitle</p>
</div>

<div class="content-main-container">
    <ng-container *ngFor="let t of contents">
        <div class="category_area">
            <div class="tag_section">
                <h3 class="search_category">{{ t.title | translate }}</h3>
                <h3 translate>voice.search_by</h3>
            </div>
            <mat-divider></mat-divider>
            <div class="tab-container">
                <div fxLayout="row wrap" fxLayoutAlign="center">
                    <div *ngFor="let c of t.content">
                        <div  (click)="onClick(c.tag)"
                              class="card"
                              matRipple
                              [matRippleRadius]="40"
                              style="background-color: {{c.color}}"
                            >
                            <span class="card-title" translate>{{c.tag}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>